"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModalPresenter = void 0;
const react_1 = require("react");
const ModalPresenterContext_1 = require("../context/ModalPresenterContext");
function useModalPresenter() {
    return (0, react_1.useContext)(ModalPresenterContext_1.ModalPresenterContext);
}
exports.useModalPresenter = useModalPresenter;
//# sourceMappingURL=useModalPresenter.js.map